
import Vue from 'vue'
import App from './App.vue'
import JsonExcel from "vue-json-excel";

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
 
Vue.use(Vuesax)

// Vue Router
import router from './router'
// axios
import axios from "./modules/helpers/axios.js"
Vue.prototype.$http = axios

Vue.prototype.$http.interceptors.request.use(
  (config) => {
   console.log(config);
   return config;
  },
  error => {
   console.log(error);
  }
);

Vue.prototype.$http.interceptors.response.use(
  response => {
    // this.isLoading = false;
    console.log(response)
    
    return response;
  },
  function(error) {
   console.log(error)
    if (error.response.status === 401) {
        localStorage.clear();
        window.location.href = ""; //Will take you to Dashboard.
    }
    else{
        alert(error.response.data.message);
    }
    
    return Promise.reject(error);
  }
);
Vue.component("downloadExcel", JsonExcel);

 
// API Calls
import "./http/requests"

// mock
import "./fake-db/index.js"

// Theme Configurations
import '../themeConfig.js'


// Firebase
import '@/firebase/firebaseConfig'


// Auth0 Plugin
import AuthPlugin from "./plugins/auth";
Vue.use(AuthPlugin);


// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'




// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuexy Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);


// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: 'YOUR_API_KEY',
        libraries: 'places', // This is required if you use the Auto complete plug-in
    },
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    acl,
    render: h => h(App)
}).$mount('#app')
